import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from '../../AxiosClient'

export const checkUser = createAsyncThunk(
  'login/check-user',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/v1/common/check-user`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
export const getDefaultRoutes = createAsyncThunk(
  'login/getDefaultRoutes',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/v1/common/get-user-with-default-route`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
